<!--
 * @ Author: Your name
 * @ Create Time: 2019-06-19 11:24:23
 * @ Modified by: Your name
 * @ Modified time: 2019-08-07 14:43:34
 * @ Description: 表格功能的封装
 -->

<template>
  <div class="table-pagination">
    <el-table
      ref="table"
      :data="showList"
      class="table-list"
      border
      resizable
      header-row-class-name="table-list-header"
      @sort-change="sortChange"
      @row-click="rowClick"
      @cell-click="cellClick"
      @selection-change="selectionChange"
      @current-change='currentChangeTable'
      :cell-style="cellStyle"
      :row-class-name="tableRowClassName"
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.6)"
      element-loading-text="数据加载中 ……"
    >
      <slot></slot>
    </el-table>

    <div class="pagination-wrapper">
      <el-pagination
      v-if="total > 0"
      style="margin-top: 5px;"
      background
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      :layout="layout"
      :total="total"
      @current-change="currentChange"
      @size-change="sizeChange"
    >
      <span class="el-pagination__show">显示 {{(currentPage - 1) * pageSize + 1}} 从
        {{(currentPage - 1) * pageSize + pageSize | checkLength(this)}} 记录
      </span>
    </el-pagination>
    </div>
  </div>
</template>

<script>

export default {
  name: 'table-pagination',
  componentName: 'TablePagination',
  props: {
    isRoleManage: {
      type: Boolean,
      default: false
    },
    isCheckbox: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Object],
      default: () => ([])
    },
    initPagination: {
      type: Object,
      default: () => ({
        currentPage: 1,
        pageSize: 20,
        pageSizes: [5, 10, 20, 50],
        layout: 'slot, total, sizes, ->, prev, pager, next, jumper'
      })
    },
    height: {
      type: Number,
      default: 530
    },
    singleSelect: {
      type: Boolean,
      default: false
    },
    service: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    checkLength(val, vm) {
      const maxLength = !vm.service ? vm.tableData.length : vm.tableData.totalSize
      return val > maxLength ? maxLength : val
    }
  },
  data() {
    // 不是后端分页， 实现前端自行截取数组的长度
    const {
      currentPage, pageSize, pageSizes, layout
    } = this.initPagination

    const showList = !this.service
      ? this.changeShowList(currentPage, pageSize, this.tableData)
      : this.tableData.data  
    return {
      selectedIndex: [],
      tempSelection: [],
      currentRowIndex: '',
      currentRow: {},
      currentPage,
      pageSize,
      pageSizes,
      layout,
      showList, // 经过判断前端分页还是后端分页 取得的 table 数据
      tableList: this.tableData // 未经处理的原始table数据
    }
  },
  watch: {
    tableData(newValue) {
      if (this.service) {
        this.showList = newValue.data
        this.tableList = newValue.data
        this.currentPage = newValue.pageNum - 0
        this.pageSize = newValue.pageSize - 0
        return
      }
      this.tableList = newValue
      this.currentPage = 1
      this.showList = this.changeShowList(this.currentPage, this.pageSize)
    }
  },
  computed: {
    total() {
      // 后端分页，直接使用 totalSize
      // 前端分页，使用数组的长度
      if (this.service) return this.tableData.totalSize
      return this.tableData.length
    }
  },
  methods: {
    // 当表格的排序条件发生变化的时候会触发该事件
    sortChange({ column, order, prop }) {
      if (this.service) { // 如果是服务端分页
        let sortBy = ''
        if (order) { // 如果需要排序
          sortBy = column.sortBy || prop
        }
        // 回调的order 值是 descending 或者 ascending
        const orderBy = order ? `${sortBy} ${order.replace('ending', '')}` : ''
        this.$emit('service-fn', { orderBy })
        return
      }
      // 前端分页
      this.$emit('sort-change', { column, order, prop })
    },
    currentChange(cur) { // 改变当前页
      this.currentPage = cur
      if (this.service) { // 如果是服务端分页
        this.$emit('service-fn', { pageNum: cur, pageSize: this.pageSize })
        return
      }
      // 前端分页，重新进行数组的截取
      this.showList = this.changeShowList(this.currentPage, this.pageSize)
    },
    // pageSize 改变时会触发， 返回 每页条数
    sizeChange(size) {
      this.pageSize = size
      if (this.service) {
        this.$emit('service-fn', { pageSize: size })
        return
      }
      this.showList = this.changeShowList(this.currentPage, this.pageSize)
    },
    // 实现数组数据的截取
    changeShowList(currentPage, pageSize, tableList = this.tableList) {
      const from = (currentPage - 1) * pageSize
      return tableList.slice(from, from + pageSize)
    },
    rowClick(row, event, column) {
      this.$emit('row-click', row, event, column, this.singleSelect)
      this.currentRow = row
      this.handleCurrentRowId(row) // 获取设置当前行所属的 index
      this.handleSelectionId() // 设置获取选中行的 id
    },
    handleCurrentRowId(row) { // 获取选中行属于第几条数据
      this.currentRowIndex = this.tableData.data.findIndex((item, index) => {
        return item.id === row.id
      })
    },
    handleSelectionId() {
      let ids = this.tempSelection.map(item => item.id) // 所有选中的 id
      let arr = []
      let tableDataSArr = [...this.tableData.data]
      if (this.isRoleManage) {
        // 处理角色管理模块
        arr = this.handleRoleManage({ tableDataSArr, ids })
      } else {
        // 处理单选和多选
        arr = this.handleMutipleSelecRadio({ tableDataSArr, ids })
      }
      this.selectedIndex = arr
    },
    handleMutipleSelecRadio({ tableDataSArr, ids }) { // 处理 单选和多选
      let arr = []
      tableDataSArr.forEach((item, index) => {
        // 多选
        if (this.isCheckbox && item.id && ids.includes(item.id)) {
          arr.push(index)
        }
        if (!this.isCheckbox) { // 单选
          arr = [this.currentRowIndex]
        }
      })
      return arr
    },
    handleRoleManage({ tableDataSArr, ids }) { // 处理角色管理
      let arr = []
      tableDataSArr = tableDataSArr.map(item => {
        return {
          ...item,
          id: item.roleName.split(',')[1]
        }
      })
      let currentId = ''
      if (this.currentRow && this.currentRow.roleName) {
        currentId = this.currentRow.roleName.split(',')[1]
      }
      const res = tableDataSArr.findIndex(item => (item.id === currentId))
      arr.push(res)
      return arr
    },
    cellClick(row, column, cell, event) {
      this.$emit('cell-click', row, column, cell, event)
    },
    currentChangeTable(currentRow, oldCurrentRow) {
      this.$emit('currentChange-table', currentRow, oldCurrentRow)
    },
    cellStyle(row, column, cell, event) {
      this.$emit('cellStyle', row, column, cell, event)
    },
    // 当选择项发生变化时会触发该事件
    selectionChange(selection) {
      this.$emit('selection-change', selection)
      this.tempSelection = selection
      this.handleSelectionId() // 设置获取选中行的 id
      // console.log('selection ===>', selection)
    },
    setCurrentRow(row) {
      this.$refs.table.setCurrentRow(row)
    },
    toggleRowSelection(row, selected) {
      this.$refs.table.toggleRowSelection(row, selected)
    },
    clearSelection(selection) {
      this.$refs.table.clearSelection(selection)
    },
    // 改变行的颜色
    tableRowClassName({ rowIndex }) {
      let classNames = 'odd-row'
      if (rowIndex % 2 === 0) { // 偶数行
        classNames = 'even-row'
      }
      if (this.selectedIndex.includes(rowIndex)) {
        classNames = 'click-row' // 选中当前行颜色
      }
      // 奇数行
      return classNames
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-pagination__show {
  font-weight: 400;
  color: #606266;
}
.table-pagination{
  .pagination-wrapper {
    margin-top: 15px
  }
}
.table-list{
  /deep/.table-list-header{ // 设置表格头部样式
    color: rgba(55,86,122,1);
    font-weight: bold;
    /deep/th{ // 设置表头行高
      padding: 2px 0px;
      height: 30px;
      line-height: 30px;
      background: #DBDBDB;
      .cell:not(:first){
        padding: 0px;
      }
      .caret-wrapper{
        .ascending{
          border-bottom-color: rgba(55,86,122,1);
        }
        .descending{
          border-top-color: rgba(55,86,122,1);
        }
      }
    }
  }
  /deep/.even-row{ // 设置奇偶行颜色
    background: #F1F1F1;
  }
  /deep/.odd-row{
    background:#E8E8E8
  }
  /deep/.click-row{
    background: #72aece6e;
  }
  /deep/td:not(.el-table-column--selection){ // 设置表格边框颜色, 行高
    border-color: #fff;
    padding: 4px 0px;
    .cell {
      // padding: 2px;
    }
  }
  // 鼠标滑过行，改变背景色
  /deep/.el-table__body tr:hover>td{ background:rgba(6, 59, 83, 0.144);}

  // 设置table中单选按钮的样式
  /deep/.el-radio__label{
    display: none;
  }
  /deep/.el-radio__inner{
    width: 16px;
    height: 16px;
  }
}

// 设置每一列的padding


/deep/.el-table__empty-block{
  background: #cccccc5c;
  span{
    color: rgba(55, 86, 122, 0.87);
    font-weight: bold;
  }
}
</style>
